import { useQuery } from '@tanstack/react-query';
import { fileRequest } from 'api/FileRequest';
import { ExperienceType } from 'helpers/constants/enums';
import { BUCHAREST_COORDINATES } from 'helpers/constants/locationCoordinates';
import { businessPackageRequest } from '../../business/BusinessPackageRequest';
import { queryKeys } from '../../constants/queryKeys';
import { SlugBasedHookOptions } from './types';

function useGetBusinessPackage({ slug, enabled = true }: SlugBasedHookOptions) {
  const QUERY_KEY = [queryKeys.businessPackage, slug];

  return useQuery({
    queryKey: QUERY_KEY,
    queryFn: () => businessPackageRequest.getBusinessPackageBySlug(slug),
    enabled,
    select: ({ experience }) => ({
      ...experience,
      id: experience.id,
      presentationPhoto: fileRequest.getPublicUrl(experience.presentationPhoto),
      presentationVideo: fileRequest.getPublicUrl(experience.presentationVideo),
      videoThumbnail: experience.presentationVideo?.thumbnailPath
        ? fileRequest.getPublicUrl({
            ...experience.presentationVideo,
            path: experience.presentationVideo.thumbnailPath,
          })
        : undefined,
      type: ExperienceType.HANDS_ON,
      isPermanent: true,
      domain: experience.domain,
      city: experience.city,
      coordinates: [
        experience.meetingPlaceLat ?? BUCHAREST_COORDINATES.lat,
        experience.meetingPlaceLng ?? BUCHAREST_COORDINATES.lng,
      ],
      createdAt: experience.createdAt,
      description: experience.description,
      price: experience.participantFee,
      currency: experience.currency,
      company: {
        id: experience.companyId,
        name: experience.company.name,
        companyLogo: fileRequest.getPublicUrl(
          experience.company.presentationPhoto
        ),
      },
      host: {
        name: experience.representativeName,
        avatar: fileRequest.getPublicUrl(experience.representativePhoto),
        position: experience.representativePosition,
      },
    }),
  });
}

export default useGetBusinessPackage;
